import { toast } from 'react-toastify';
import { ProgramStatus } from '../../../../api/types/programs/program-status';
import appApi from '../../../../api/app-api';
import { ProgramType } from '../../../../api/types/programs/program.type';

export const updateProgramStatusOperation = async (
  branchId: number | undefined,
  programId: number | undefined,
  status: ProgramStatus,
  setLoading: (loading: boolean) => any,
  programType: ProgramType,
  setProgramType: (program: ProgramType) => any,
) => {
  try {
    if (isNaN(Number(branchId)) || isNaN(Number(programId))) {
      toast.warn(
        'לא ניתן לאתר את מזהה השלוחה או התוכנית המבוקשת, נסה שוב בעוד מספר רגעים',
      );
      return;
    }
    setLoading(true);
    await appApi.updateProgramStatus(branchId!, programId!, status);
    const updatedProgramType = {
      ...programType,
      metadata: {
        ...programType.metadata,
        status: status, // Update the status in metadata
      },
    };
    setProgramType(updatedProgramType);

    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `updateProgramStatusOperation is failed with the and the error: ${e}`,
    );
    toast.error('עדכון סטטוס התוכנית נכשלה, נסה שוב בעוד מספר רגעים');
  }
};
